import { Form, Input, Radio } from "antd";
import * as React from "react";
import { ObjectO2 } from "src/pages/ManagementPage/Obj2Tab/Obj2Nodes";
import { ZAttribute } from "src/types/ZAttribute";
import { AttrTypeName } from "src/types/AttrType";
import { ZUid } from "src/types/zUid";
import styles from "./Planning2Settings.module.less";
import { AttrSection, BsObjectSection } from "../../../BsObjectSection";
import { ZPlanning2Settings } from "../ZPlanning2Settings";

type PropsPlanning2Settings = {
  typesMap: Record<number, string>;
  objList: ObjectO2[];
  mainObjectId: ZUid;
};

const f = (key: keyof ZPlanning2Settings): string => key;

export const Planning2Settings: React.FC<PropsPlanning2Settings> = (props) => {
  const { objList, typesMap, mainObjectId } = props;
  const singleType = (typeName: AttrTypeName) => (attr: ZAttribute) =>
    typesMap[attr.valueType] === typeName;
  const idValue = Form.useWatch(f("id"));
  const curObject =
    idValue === undefined
      ? undefined
      : objList.find(
          (it) => it.type === "obj" && it.object.id === mainObjectId,
        );
  return (
    <>
      <Form.Item name={f("id")} noStyle>
        <Input type="hidden" />
      </Form.Item>
      <h3>{curObject?.object.name}</h3>
      <div style={{ width: "50%" }}>
        <Form.Item
          name={f("planDateReversedCalculation")}
          label="Направление расчета плановых дат"
        >
          <Radio.Group
            defaultValue={false}
            className={styles.radioGroup}
            disabled={!!idValue}
          >
            <Radio value={false}>Вперёд — от даты начала плана</Radio>
            <Radio value>Назад — от даты окончания плана</Radio>
          </Radio.Group>
        </Form.Item>
        <AttrSection
          attrDef={{
            label: "Дата начала/окончания календарного плана",
            attrName: f("relationPlanDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
            optional: true,
          }}
          curObject={curObject}
        />
      </div>
      <h3>Задача</h3>
      <BsObjectSection
        objName={f("taskObjectId")}
        objLabel="Объект Задача"
        objList={objList}
        attrs={[
          {
            label: "Связь с объектом бизнес-сервиса",
            attrName: f("relationLinkAttributeId"),
            attrValid: singleType(AttrTypeName.object),
          },
          {
            label: "Тип задачи",
            attrName: f("taskTypeAttributeId"),
            attrValid: singleType(AttrTypeName.dictSingle),
          },
          {
            label: "Длительность",
            attrName: f("durationAttributeId"),
            attrValid: singleType(AttrTypeName.int),
          },
          {
            label: "Департамент",
            attrName: f("departmentAttributeId"),
            attrValid: singleType(AttrTypeName.dictSingle),
          },
          {
            label: "Исполнитель",
            attrName: f("employeeAttributeId"),
            attrValid: singleType(AttrTypeName.usersList),
          },
          {
            label: "Приоритет",
            attrName: f("priorityAttributeId"),
            attrValid: singleType(AttrTypeName.dictSingle),
          },
          {
            label: "Группа задач",
            attrName: f("taskGroupAttributeId"),
            attrValid: singleType(AttrTypeName.dictSingle),
          },
          {
            label: "Предыдущая задача",
            attrName: f("previousTaskLinkAttributeId"),
            attrValid: singleType(AttrTypeName.object),
          },
          {
            label: "Название",
            attrName: f("nameAttributeId"),
            attrValid: singleType(AttrTypeName.string),
          },
          {
            label: "Предыдущая задача шаблона",
            attrName: f("previousTemplateTaskLinkAttributeId"),
            attrValid: singleType(AttrTypeName.object),
          },
          {
            label: "Плановая дата начала",
            attrName: f("plannedStartDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
            onNewLine: true,
          },
          {
            label: "Плановая дата окончания",
            attrName: f("plannedEndDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
          },
          {
            label: "Фактическая дата начала",
            attrName: f("actualStartDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
          },
          {
            label: "Фактическая дата окончания",
            attrName: f("actualEndDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
          },
          {
            label: "Прогнозная дата начала",
            attrName: f("forecastStartDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
          },
          {
            label: "Прогнозная дата окончания",
            attrName: f("forecastEndDateAttributeId"),
            attrValid: singleType(AttrTypeName.date),
          },
          {
            label: "Отставание задачи",
            attrName: f("delayAttributeId"),
            attrValid: singleType(AttrTypeName.int),
          },
          {
            label: "Связь Задачи и Шаблона",
            attrName: f("templateLinkAttributeId"),
            attrValid: singleType(AttrTypeName.object),
          },
        ]}
      />
      <div style={{ height: 40 }} />
    </>
  );
};
